import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class UndefinedVariableInterceptor implements ErrorHandler {
  handleError(error: any): void {
    console.log('Error: ', error);
    try {
      if (
        error.message.includes('undefined') ||
        error.message.includes('is not defined') ||
        error.message.includes('ng0100')
      ) {
        console.error('Inter: ', error);
      } else {
        console.error('Other: ', error);
        throw error;
      }
    } catch (error) {
      console.error('Catch: ', error);
    }
  }
}
